import { render } from "./AbilityView.vue?vue&type=template&id=1e794be6&lang=true"
import script from "./AbilityView.vue?vue&type=script&lang=js"
export * from "./AbilityView.vue?vue&type=script&lang=js"
script.render = render

export default script